/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CopropertyDto } from './CopropertyDto';
import {
    CopropertyDtoFromJSON,
    CopropertyDtoFromJSONTyped,
    CopropertyDtoToJSON,
    CopropertyDtoToJSONTyped,
} from './CopropertyDto';
import type { GetRealEstateWithTenantsResponse } from './GetRealEstateWithTenantsResponse';
import {
    GetRealEstateWithTenantsResponseFromJSON,
    GetRealEstateWithTenantsResponseFromJSONTyped,
    GetRealEstateWithTenantsResponseToJSON,
    GetRealEstateWithTenantsResponseToJSONTyped,
} from './GetRealEstateWithTenantsResponse';
import type { PersonDto } from './PersonDto';
import {
    PersonDtoFromJSON,
    PersonDtoFromJSONTyped,
    PersonDtoToJSON,
    PersonDtoToJSONTyped,
} from './PersonDto';

/**
 * Insured risk of the quote of a validation request, read only. The branch view (mri or gli) is absent for the branches without one.
 * 
 * @export
 * @interface GetRisqueDevisResponse
 */
export interface GetRisqueDevisResponse {
    /**
     * Branch code of the insured risk (e.g. MRI, GLI)
     * @type {string}
     * @memberof GetRisqueDevisResponse
     */
    codeBranche?: string | null;
    /**
     * People of the risk, natural persons first, then legal entities
     * @type {Array<PersonDto>}
     * @memberof GetRisqueDevisResponse
     */
    souscripteurs: Array<PersonDto>;
    /**
     * 
     * @type {CopropertyDto}
     * @memberof GetRisqueDevisResponse
     */
    mri?: CopropertyDto;
    /**
     * 
     * @type {GetRealEstateWithTenantsResponse}
     * @memberof GetRisqueDevisResponse
     */
    gli?: GetRealEstateWithTenantsResponse;
}

/**
 * Check if a given object implements the GetRisqueDevisResponse interface.
 */
export function instanceOfGetRisqueDevisResponse(value: object): value is GetRisqueDevisResponse {
    if (!('souscripteurs' in value) || value['souscripteurs'] === undefined) return false;
    return true;
}

export function GetRisqueDevisResponseFromJSON(json: any): GetRisqueDevisResponse {
    return GetRisqueDevisResponseFromJSONTyped(json, false);
}

export function GetRisqueDevisResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRisqueDevisResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'codeBranche': json['codeBranche'] == null ? undefined : json['codeBranche'],
        'souscripteurs': ((json['souscripteurs'] as Array<any>).map(PersonDtoFromJSON)),
        'mri': json['mri'] == null ? undefined : CopropertyDtoFromJSON(json['mri']),
        'gli': json['gli'] == null ? undefined : GetRealEstateWithTenantsResponseFromJSON(json['gli']),
    };
}

export function GetRisqueDevisResponseToJSON(json: any): GetRisqueDevisResponse {
    return GetRisqueDevisResponseToJSONTyped(json, false);
}

export function GetRisqueDevisResponseToJSONTyped(value?: GetRisqueDevisResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'codeBranche': value['codeBranche'],
        'souscripteurs': ((value['souscripteurs'] as Array<any>).map(PersonDtoToJSON)),
        'mri': CopropertyDtoToJSON(value['mri']),
        'gli': GetRealEstateWithTenantsResponseToJSON(value['gli']),
    };
}

